interface Props { value: number; supported: boolean; onChange: (value: number) => void; }
export function LookAheadControl({ value, supported, onChange }: Props) {
  return <section className="instrument-section look-ahead-section">
    <label htmlFor="look-ahead" className="look-ahead-label">
      <span>Look Ahead</span><span>{supported ? value.toFixed(0) + " ms" : "N/A"}</span>
    </label>
    <input id="look-ahead" type="range" min={0} max={1000} step={10}
      value={supported ? value : 0} disabled={!supported}
      title={supported ? "延迟音频，让画面提前响应" : "当前实时音源不支持 Look Ahead"}
      onChange={event => onChange(event.currentTarget.valueAsNumber)} />
    {!supported && <p className="control-note">当前实时音源不支持预读</p>}
  </section>;
}
